import { Domain } from './domain';
import { WebAuthOrigin } from './web-auth-origin';

const legacyUatDomain = 'hsuat.com';
const legacyProdDomain = 'hedgeserv.com';
const uatDomain = 'hsftuat.com';
const prodDomain = 'hsft.com';

export function getServiceRoot(location: Location): string {
    const { hostname, origin } = location;

    if (hostname.endsWith('.poc-rnd.hsuat.com')) {
        return WebAuthOrigin.LEGACY_RND;
    }

    if (hostname.endsWith('.app-qa.hsuat.com')) {
        return WebAuthOrigin.LEGACY_QA;
    }

    if (hostname.endsWith('.hsuat.com')) {
        return WebAuthOrigin.LEGACY_UAT;
    }

    if (hostname.endsWith('.app-tst.hedgeserv.com')) {
        return WebAuthOrigin.LEGACY_TST;
    }

    if (hostname.endsWith('.hedgeserv.com')) {
        return WebAuthOrigin.LEGACY_PROD;
    }

    if (hostname.endsWith('.poc-rnd.hsftuat.com')) {
        return WebAuthOrigin.RND;
    }

    if (hostname.endsWith('.app-qa.hsftuat.com')) {
        return WebAuthOrigin.QA;
    }

    if (hostname.endsWith('.hsftuat.com')) {
        return WebAuthOrigin.UAT;
    }

    if (hostname.endsWith('.app-tst.hsft.com')) {
        return WebAuthOrigin.TST;
    }

    if (hostname.endsWith('.hsft.com')) {
        return WebAuthOrigin.PROD;
    }

    return `${origin}/wauth`;
}

export function getEnvironment(location: Location): string {
    const { hostname } = location;

    if (hostname.includes(Domain.LEGACY_RND) || hostname.includes(Domain.RND)) {
        return 'rnd';
    }

    if (hostname.includes(Domain.LEGACY_UAT) || hostname.includes(Domain.UAT)) {
        return 'uat';
    }

    if (hostname.includes(Domain.LEGACY_QA) || hostname.includes(Domain.QA)) {
        return 'qa';
    }

    if (hostname.includes(Domain.LEGACY_TST) || hostname.includes(Domain.TST)) {
        return 'tst';
    }

    if (hostname.includes(Domain.LEGACY_PROD) || hostname.includes(Domain.PROD)) {
        return 'prod';
    }

    return 'local';
}

export function getApmHost(hostname: string): string {
    if (hostname.includes(legacyUatDomain)) {
        return `https://access.${legacyUatDomain}`;
    }

    if (hostname.includes(uatDomain)) {
        return `https://access.${uatDomain}`;
    }

    if (hostname.includes(legacyProdDomain)) {
        return `https://access.${legacyProdDomain}`;
    }

    if (hostname.includes(prodDomain)) {
        return `https://access.${prodDomain}`;
    }

    return '';
}

export function getReportRunnerLocation(location: Location): string {
    return buildAppUrl('reportrunner', location);
}

export function getCrosstalkRoot(location: Location): string {
    return buildAppUrl('crosstalk', location);
}

export function getCrosstalkManagementRoot(location: Location): string {
    const url = buildAppUrl('crosstalk', location);

    // In the previous version of the file, this by default returned RND URL
    // However with the rebranding we cannot determine in this function whether we're using
    // legacy of the new domain name
    // So until we fully switch to the new this will default to the legacy RND URL
    return url || `https://crosstalk.${Domain.LEGACY_RND}`;

    // Once fully switched to the new domain uncomment this line and delete the line returning the legacy domain
    // return url || `https://crosstalk.${Domain.RND}`;
}

function buildAppUrl(app: string, location: Location): string {
    const environment = getEnvironment(location);
    const hostname = location.hostname;

    switch (environment) {
        case 'rnd':
            return hostname.includes(legacyUatDomain) ?
                `https://${app}.${Domain.LEGACY_RND}` :
                `https://${app}.${Domain.RND}`;
        case 'uat':
            return hostname.includes(legacyUatDomain) ?
                `https://${app}.${Domain.LEGACY_UAT}` :
                `https://${app}.${Domain.UAT}`;
        case 'qa':
            return hostname.includes(legacyUatDomain) ?
                `https://${app}.${Domain.LEGACY_QA}` :
                `https://${app}.${Domain.QA}`;
        case 'tst':
            return hostname.includes(legacyProdDomain) ?
                `https://${app}.${Domain.LEGACY_TST}` :
                `https://${app}.${Domain.TST}`;
        case 'prod':
            return hostname.includes(legacyProdDomain) ?
                `https://${app}.${Domain.LEGACY_PROD}` :
                `https://${app}.${Domain.PROD}`;
        default:
            return '';
    }
}
